import { render } from "./DonorDetailsComponent.vue?vue&type=template&id=5371f6d5&scoped=true"
import script from "./DonorDetailsComponent.vue?vue&type=script&lang=js"
export * from "./DonorDetailsComponent.vue?vue&type=script&lang=js"

import "./DonorDetailsComponent.vue?vue&type=style&index=0&id=5371f6d5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5371f6d5"]])

export default __exports__